import styles from './style.module.css';

// One of the sheet's seven mood states as a choice: its colour, its name, and
// the sheet's own description of what it means for daily life.
export function MoodOption({ level, name, anchor }) {
  let description = null;

  if (anchor !== '') {
    description = <span className={ styles.anchor }>{ anchor }</span>;
  }

  return (
    <span className={ styles.option }>
      <span className={ styles.swatch } style={ { '--swatch': `var(--mood-${ level })` } }></span>

      <span className={ styles.text }>
        <span className={ styles.name }>{ name }</span>

        { description }
      </span>
    </span>
  );
}
